// 사이드바 아이템 정의 (현재 사용되지 않음 - defaultRoutes.ts에서 관리)
export const sidebarItems: any[] = [];

// InnerTab 여부 확인 함수
export const isInnerTab = (menuType: string): boolean => {
  return menuType === "T" || menuType === "INNER_TAB";
};

// InnerTab 쿼리 처리 함수
export const getQueryForInnerTab = (params: Record<string, any>): Record<string, any> => {
  const query: Record<string, any> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query[key] = value;
    }
  });

  return query;
};
